import Cookies from 'js-cookie';
import app from '../app/app.es6';

let appGrid;
let templateRequest;
let deferredTemplateRequest;

function appGridBusy( busy ) {
	if( !appGrid ) { return; }
	appGrid.setAttribute( 'aria-busy', busy ? 'true' : 'false' );

	const loader = appGrid.querySelector( '.loading' );
	const loaderClass = 'loading--active';
	if( busy ) {
		loader.classList.add( loaderClass );
	} else {
		loader.classList.remove( loaderClass );
	}
}

function setupTemplateRequest( getData ) {
	templateRequest = getData;
		
	if( deferredTemplateRequest ) {
		templateRequest( deferredTemplateRequest );
		deferredTemplateRequest = null;
	}
}

function errorState( noResults ) {
	appGridBusy( false );
	
	appGrid.querySelector( '.grid-row' ).replaceChildren();
	
	const noResultsEle = appGrid.querySelector( '.app-grid__no-results' );
	const errorEle = appGrid.querySelector( '.app-grid__error' );

	if( noResults ) {
		const searchTerm = document.querySelector( '.hero--appstore__tools__search input' ).value.trim();
		const searchTermError = noResultsEle.querySelector( '.app-grid__search-error' );

		if( searchTerm ) {
			searchTermError.style.display = 'block';
			noResultsEle.querySelector( '.app-grid__search-term' ).textContent = searchTerm;
		} else {
			searchTermError.style.display = 'none';
		}

		noResultsEle.style.display = 'block';
	} else {
		errorEle.style.display = 'block';
	}

	const headingEle = appGrid.querySelector( '.heading' );
	headingEle.style.display = 'none';
}

function renderAppGrid( results ) {
	if( !appGrid || !results || !results.data || !results.meta ) {
		errorState();
		return;
	}

	// Use URL parameter to determin if MyAppList is turned on
	const endPoint = document.querySelector('.facet-filter').dataset.initialEndpoint;
	const urlParams = new URLSearchParams(endPoint);
	const isMyAppList = urlParams.get('filter[myapplist]');

	if( !results.data.length ) {
		errorState( true );
		return;
	}
	
	const resultsEle = appGrid.querySelector( '.grid-row' );
	const resultItems = results.data || [];
	const resultIncluded = results.included || [];
	const totalResults = results.meta.count;
	const resultMeta = results.meta.facets || [];
	const metaDevices = resultMeta.find(e => e.id === 'devices').terms || [];

	// remove the contents of the results list so we can populate it all over again
	resultsEle.replaceChildren();

	// Hide the error messages
	appGrid.querySelector( '.app-grid__error' ).style.display = 'none';
	appGrid.querySelector( '.app-grid__no-results' ).style.display = 'none';

	// Update the title
	const headingEle = appGrid.querySelector( '.heading' );
	const titleEle = headingEle.querySelectorAll( 'h3 strong' );
	if( titleEle.length ) {
		titleEle[0].textContent = resultItems.length;
		titleEle[1].textContent = totalResults;
	}
	headingEle.style.display = 'flex';

	for ( let step = 0; step < resultItems.length; step += 1 ) {
		const nodeID = resultItems[step].attributes.drupal_internal__nid;
		const imageID = resultItems[step].relationships.field_app_icon?.data?.id || null;
		const linkPath = resultItems[step].attributes.path.alias;
		const resourceTitle = resultItems[step].attributes.title;
		const requiresLogin = resultItems[step].attributes.field_login_required;
		const features = resultItems[step].attributes.field_app_features;
		const devices = resultItems[step].relationships.field_devices?.data.map(x => x.meta.drupal_internal__target_id) || null;

		let resourceDescription = resultItems[step].attributes.body?.summary.length ? resultItems[step].attributes.body.summary : ( resultItems[step].attributes.body?.value || null );
		const temp = document.createElement( 'div' );
		temp.innerHTML = resourceDescription;
		Array.from( temp.querySelectorAll( 'style, script' ) ).forEach( ( ele ) => { ele.remove(); } ); // remove style and script tags
		resourceDescription = temp.innerHTML.replace( /<[^>]+>/g, '' ).trim(); // remove all other HTML tags
		const maxlen = 255;
		if( resourceDescription.length > maxlen ) {
			resourceDescription = `${resourceDescription.substring( 0, maxlen )}…`;
		}
	
		let fileID; let fileURL; let fileAlt;
		if( imageID != null ) {
			const imageIndex = resultIncluded.map( ( e ) => ( e.id ) ).indexOf( imageID );
			if( resultIncluded[imageIndex] ) {
				fileID = resultIncluded[imageIndex].relationships.field_media_image.data.id;

				const fileIndex = resultIncluded.map( ( e ) => ( e.id ) ).indexOf( fileID );
				if( resultIncluded[fileIndex]) {
					fileURL = resultIncluded[fileIndex].attributes.uri.url || null;
					fileAlt = resultIncluded[imageIndex].relationships.field_media_image.data.meta?.alt || null;
				}
			}
		}

		const modalID = 'modal-' + resourceTitle.toLowerCase().replaceAll(' ', '-');

		// Construct App result markups
		const resultItem = document.createElement( 'div' );
		resultItem.classList.add( 'grid-col-12', 'tablet:grid-col-6', 'desktop:grid-col-6');

		const appItem = document.createElement('div');
		appItem.classList.add('app');

		// App Thumbnail
		const appItemThumbnail = document.createElement('a');
		appItemThumbnail.classList.add('app__thumbnail');

		const appItemThumbnailImage = document.createElement('img');
		appItemThumbnailImage.classList.add('app__image');
		appItemThumbnailImage.src = fileURL;
		appItemThumbnailImage.setAttribute('alt', fileAlt);
		appItemThumbnail.append(appItemThumbnailImage);

		// App Content
		const appItemContent = document.createElement('div');
		appItemContent.classList.add('app__content');

		const appItemTitle = document.createElement('h4');
		appItemTitle.classList.add('h6', 'app__name');
		if(requiresLogin){ appItemTitle.classList.add('app--lock'); }

		const appItemTitleLink = document.createElement('a');
		appItemTitleLink.href = linkPath;
		appItemTitleLink.innerHTML = resourceTitle;
		appItemTitle.appendChild(appItemTitleLink);

		const appItemPrintUrl = document.createElement('div');
		appItemPrintUrl.classList.add('d-none', 'd-print-block');
		appItemPrintUrl.innerText = window.location.protocol + '//' + window.location.hostname + linkPath;

		const appItemDescription = document.createElement('div');
		appItemDescription.classList.add('d-print-none', 'app__description');
		appItemDescription.innerHTML = resourceDescription;

		const appItemQuickFeatureToggle = document.createElement('a');
		appItemQuickFeatureToggle.href = '#' + modalID;
		appItemQuickFeatureToggle.classList.add('quickfeature__toggle');
		appItemQuickFeatureToggle.innerText = 'Quick Features';
		appItemQuickFeatureToggle.setAttribute('aria-controls', modalID);
		appItemQuickFeatureToggle.setAttribute('data-open-modal', '');

		if(isMyAppList) {
			appItemDescription.append(appItemQuickFeatureToggle);
		}

		const appItemExtra = document.createElement('div');
		appItemExtra.classList.add('app__extra');

		const appItemTagGroup = document.createElement('div');
		appItemTagGroup.classList.add('tag-group');


		// Build Devices Tag Group				
		if(devices) {
			let appItemTags = '';

			metaDevices.forEach(metaDevice => {
				if(devices.includes(Number(metaDevice.values.value))) {
					appItemTags += '<div class="tag"><a href="/appstore?filter%5Bdevices%5D='+metaDevice.values.value+'">'+metaDevice.values.label+'</a></div>';
				}
			});

			appItemTagGroup.innerHTML = appItemTags;
			appItemExtra.append(appItemTagGroup);
		};

		const appItemMyAppListToggle = document.createElement('button');
		appItemMyAppListToggle.classList.add('usa-button', 'usa-button--outline', 'usa-button--mid', 'usa-button--icon-pre', 'myapplist__toggle');
		if( app.isInMyAppList(nodeID) ) { 
			appItemMyAppListToggle.classList.add('in_myapplist'); // if app is in MyAppList	
		}
		appItemMyAppListToggle.innerText = app.isInMyAppList(nodeID) ? 'Remove from List':'Add to List';
		appItemMyAppListToggle.setAttribute('data-app-id', nodeID);

		if(isMyAppList) {
			appItemExtra.append(appItemMyAppListToggle);
		}

		appItemContent.append(
			appItemTitle, 
			appItemPrintUrl,
			appItemDescription,
			appItemExtra
			);

		// App Modal
		const appItemModalHeaderRight = document.createElement('div');
		appItemModalHeaderRight.classList.add('quickfeature__heading__right');
		appItemModalHeaderRight.append(appItemTitle.cloneNode(true), appItemTagGroup.cloneNode(true));
		
		const appItemModalHeader = document.createElement('div');
		appItemModalHeader.classList.add('quickfeature__header');
		appItemModalHeader.append(appItemThumbnail.cloneNode(true), appItemModalHeaderRight);

		const appItemQuickFeatureContent = document.createElement('div');
		appItemQuickFeatureContent.classList.add('quickfeature__content');
		appItemQuickFeatureContent.innerHTML = features ? features.value : '';
		
		const appItemLearnMoreBtn = document.createElement('a');
		appItemLearnMoreBtn.classList.add('usa-button', 'usa-button--unstyled', 'usa-button--icon-post', 'usa-button--next');
		appItemLearnMoreBtn.href = '#';
		appItemLearnMoreBtn.innerHTML = 'Visit app page to learn more';

		const appItemModalBody = document.createElement('div');
		appItemModalBody.classList.add('quickfeature__body');
		appItemModalBody.innerHTML = '<h3 class="margin-top-0 margin-bottom-3">Features</h3>';
		appItemModalBody.append(appItemQuickFeatureContent, appItemLearnMoreBtn);

		const appItemModalFooter = document.createElement('footer');
		appItemModalFooter.classList.add('quickfeature__footer');
		appItemModalFooter.innerHTML = '<p><b>Like what you see? Select the app to share with yourself or someone else.</b></p>';
		appItemModalFooter.append(appItemMyAppListToggle.cloneNode(true));

		const appItemModalMain = document.createElement('div');
		appItemModalMain.classList.add('usa-modal__main');
		appItemModalMain.append(appItemModalHeader, appItemModalBody, appItemModalFooter);

		const appItemModalContent = document.createElement('div');
		appItemModalContent.classList.add('usa-modal__content');
		appItemModalContent.append(appItemModalMain);

		const appItemModalCloseBtn = document.createElement('button');
		appItemModalCloseBtn.classList.add('usa-modal__close');
		appItemModalCloseBtn.setAttribute('data-close-modal', '');
		appItemModalCloseBtn.innerHTML = '<span class="sr-only">Close Modal</span>';

		const appItemModal = document.createElement('div');
		appItemModal.classList.add('usa-modal', 'usa-modal--lg', 'quickfeature');
		appItemModal.append(appItemModalContent, appItemModalCloseBtn);

		const appItemModalOverlay = document.createElement ('div');
		appItemModalOverlay.classList.add('usa-modal-overlay');
		appItemModalOverlay.append(appItemModal);

		const appItemModalWrapper = document.createElement('div');
		appItemModalWrapper.classList.add('is-hidden', 'usa-modal-wrapper');
		appItemModalWrapper.setAttribute('role', 'dialog');
		appItemModalWrapper.setAttribute('id', modalID);
		appItemModalWrapper.append(appItemModalOverlay);
		
		// Build App Cards
		appItem.append(appItemThumbnail, appItemContent);
		resultItem.append(appItem);
		resultsEle.appendChild(resultItem);

		document.body.append(appItemModalWrapper); //Append modal before body ends like USWDS do
	}

	// Trigger an event when appgrid finished rendering
	const event = new CustomEvent("AppGrid.complete", {
		detail: "App grid has been rendered",
	});

	document.dispatchEvent(event);
	appGridBusy( false );
}

function init() {
	appGrid = document.querySelector( '.page-appstore__results .app-grid' );
}

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	init();
} else {
	let eventSrcUrl = null;
	document.addEventListener('DOMContentLoaded', ( e ) => {
		if( eventSrcUrl !== e.target.URL ) {
			eventSrcUrl = e.target.URL
			init();
		}
	} );
}

export default {
	setupTemplateRequest, // call this to setup the 2-way communication
	renderAppGrid, // call this when the page recieves new data
	appGridBusy, // call this when the page initiates a new request
};